import React from "react";

export const Divider: React.FC = () => <div className="mt-6 border-t border-gray-200 pt-6" />;
